import React, { Component } from 'react';
import { CardBody, CardTitle, Form, Row, Col, Label, Button } from 'reactstrap';

import { InputDay, InputTime } from '../components';

class Hours extends Component {
  constructor(props) {
    super(props);

    this.renderRows = this.renderRows.bind(this);
  }

  state = {
    days: {
      placeholder: [['12:00', '14:00']],
      sunday: [['01:00', 'placeholder'], ['placeholder', 'placeholder']],
      monday: [['placeholder', 'placeholder']],
      thursday: [['12:00', '14:00']],
    },
    days1: [
      { day: 'monday', open: '00:00', close: '15:00' },
      { day: 'monday', open: '00:00', close: '15:00' },
    ],
  };

  setDayForSection = (day, section, day1) => {};

  setHourForSection = (day, section, hour) => {};

  renderRows = (day) => {
    const sections = this.state.days[day];
    if (sections === undefined) {
      return null;
    }

    return sections.map(section => (
      <div>
        <br />
        <Form>
          <Row>
            <Col sm="5">
              <Label>Day</Label>
            </Col>
            <Col sm="3">
              <Label>Open</Label>
            </Col>
            <Col sm="3">
              <Label>Close</Label>
            </Col>
            <Col sm="auto" />
          </Row>
          <Row>
            <Col sm="5">
              <InputDay
                bsSize="lg"
                value={day}
                onChange={e => this.setDayForSection(day, section[0], e.target.value)}
              />
            </Col>
            <Col sm="3">
              <InputTime
                bsSize="lg"
                value={section[0]}
                onChange={e => this.setHourForSection(day, section[0], e.target.value)}
              />
            </Col>
            <Col sm="3">
              <InputTime
                bsSize="lg"
                value={section[1]}
                onChange={e => this.setHourForSection(day, section[1], e.target.value)}
              />
            </Col>
            <Col sm="auto">
              <Button color="danger" size="lg">
                X
              </Button>
            </Col>
          </Row>
        </Form>
      </div>
    ));
  };

  // renderRows = (day, hours) => (
  //   <Form>
  //     <Row>
  //       <Col sm="5">
  //         <Label>Day</Label>
  //       </Col>
  //       <Col sm="3">
  //         <Label>Open</Label>
  //       </Col>
  //       <Col sm="3">
  //         <Label>Close</Label>
  //       </Col>
  //       <Col sm="auto" />
  //     </Row>
  //     <Row>
  //       <Col sm="5">
  //         <InputDay bsSize="lg" value={day} />
  //       </Col>
  //       <Col sm="3">
  //         <InputTime bsSize="lg" />
  //       </Col>
  //       <Col sm="3">
  //         <InputTime bsSize="lg" />
  //       </Col>
  //       <Col sm="auto">
  //         <Button color="danger" size="lg">
  //           X
  //         </Button>
  //       </Col>
  //     </Row>
  //   </Form>
  // );

  render() {
    return (
      <div style={{ backgroundColor: '#fff' }}>
        <CardBody>
          <CardTitle>Hours</CardTitle>
          {this.renderRows('sunday')}
          {this.renderRows('monday')}
          {this.renderRows('tuesday')}
          {this.renderRows('wednesday')}
          {this.renderRows('thursday')}
          {this.renderRows('friday')}
          {this.renderRows('saturday')}
          {this.renderRows('placeholder')}
        </CardBody>
      </div>
    );
  }
}
// {Object.keys(this.state.days).map(day => this.renderRows(day, this.state.days[day]))}

export { Hours };



// WEBPACK FOOTER //
// ./src/business/register/components/hours.js